import store from '@/store';

function isGranted (roles) {
  return store.getters['auth/isGranted'](roles);
}

export default {
  install: function (Vue) {
    Vue.prototype.$isGranted = isGranted;
  },
};
